(function(root){
  const labelFor=(description,override='')=>{
    const explicit=override.trim();
    if(/^(none|off|false)$/i.test(explicit))return '';
    if(explicit)return explicit;
    const text=description.toLowerCase().replace(/\u00a0/g,' ');
    if(!/\borganic\b/.test(text))return '';
    const clauses=text.split(/[.!?;•\n]/).map(s=>s.trim()).filter(Boolean);
    const materials=['cotton','linen','hemp','wool','silk','bamboo'];
    for(const material of materials){
      const claim=new RegExp('\\borganic\\s+'+material+'\\b');
      const positive=clauses.filter(c=>claim.test(c)&&!/(?:\bnon[\s-]*organic\b|\bnot\b|\bno\b|\bwithout\b|\bfree of\b|\bdoesn.t\b|\bisn.t\b|\bnot included\b|\bpackaging\b|\bgift wrap\b|\borganic food\b|\bgarden\b|\bcotton candy\b)/.test(c));
      // Require an actual material/content assertion, rather than an isolated marketing keyword.
      const supported=positive.filter(c=>/(?:\d+\s*%|\bmade\b|\bfabric\b|\bcontent\b|\bmaterial\b|\bexterior\b|\binterior\b|\blining\b|\bblend\b|\btwill\b|\bknit\b|\bsoft organic\b)/.test(c));
      if(!supported.length)continue;
      const component=supported.join(' ');
      if(/\bblend\b|\bpolyester\b|\belastane\b|\bnylon\b|\b(?:[1-9]|[1-9]\d)\s*%\s*organic\b/.test(component))return 'Contains organic '+material;
      if(/\blining\b/.test(component)&&!supported.some(c=>/100\s*%\s*organic/.test(c)&&!c.includes('lining')))return 'Organic '+material+' lining';
      if(/\bexterior\b/.test(component)&&!supported.some(c=>!c.includes('exterior')&&!c.includes('interior')))return 'Organic '+material+' exterior';
      return 'Organic '+material;
    }
    return '';
  };
  root.OrganicMaterial={labelFor};
  if(typeof module!=='undefined')module.exports={labelFor};
})(typeof window==='undefined'?globalThis:window);
